import { styled } from "@mui/material/styles";
import { Box, CircularProgress } from "@mui/material";

export const LoadingOverlay = styled(Box)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backdropFilter: "blur(0.2px)",
  backgroundColor: "rgba(0, 0, 0, 0.65)",
  zIndex: 10,
}));

interface LoadingOverlayWithSpinnerProps {
  size?: number;
}

export const LoadingOverlayWithSpinner: React.FC<
  LoadingOverlayWithSpinnerProps
> = ({ size = 40 }) => (
  <LoadingOverlay>
    <CircularProgress size={size} />
  </LoadingOverlay>
);
